import React, { useState, useEffect } from 'react';
import CustomTitle from '../../components/UI/title/CustomTitle';
import MyButton from '../../components/UI/button/MyButton';
import { WithWizard } from 'react-albus-react18';
import axios from 'axios';
import './style.scss';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch, useSelector } from 'react-redux';
import { setBrandName } from '../../store/scrappingSlice';
import { useSearchParams } from 'react-router-dom';
import { setIsShowButton } from '../../store/buttonSlice';
import PageContent from '../../components/PageContent/PageContent';
import useMixpanel from '../../hooks/useMixpanel';
import CryptoJS from 'crypto-js';
import { useCheckSubscriptionQuery, useCreateBusinessProfileMutation, useRegisterMutation, useSearchBusinessProfilesQuery, useUpdateUsersMutation } from '../../api/dataApi';
import useFaceBook from '../../hooks/useFaceBook';
import { use } from 'react';

const Name = ({ save }) => {
    const history = useHistory();
    const { brandName } = useSelector((state) => state.scrapping);
    const dispatch = useDispatch();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const { trackP1Event } = useMixpanel();
    const { sendFb } = useFaceBook();

    useEffect(() => {
        dispatch(setIsShowButton(false));
    }, []);



    const [isButtonDisabled, setIsButtonDisabled] = useState(true);


    const [name, setName] = useState(save ? brandName : '');

    const handleInputChange = (event) => {
        // const newValue = event.target.value.replace(/\s+/g, ''); 
        setName(event.target.value);
        setError('');
        localStorage.setItem('name', event.target.value);
    };

    useEffect(() => {
        if (name.replace(/\s+/g, '') === '') {
            setIsButtonDisabled(true);
        } else {
            setIsButtonDisabled(false);
        }
    }, [name]);

    const [error, setError] = useState('');

    const secretKey = 'j5wbjG3jNJMCSI9';

    const encryptText = (text) => {
        const ciphertext = CryptoJS.AES.encrypt(text, secretKey).toString();
        return ciphertext;
    };

    const decryptText = (ciphertext) => {
        const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
        const original = bytes.toString(CryptoJS.enc.Utf8);
        return original;
    };


    
    const decryptEmail = decryptText(queryParams.get('ue') || "") || "";

    const [register, { isLoading, isError, isSuccess, errorRegister }] = useRegisterMutation();

    const { data: subscriptionData, error: subscriptionError, isLoading: isSubscriptionLoading } = useCheckSubscriptionQuery(decryptEmail);
    const [updateUsers, { isLoading: isUpdatingUserEmail, error: updateUsersError }] = useUpdateUsersMutation();



    // const { data: subscriptionsData, error: subscriptionsError, isLoading: isSubscriptions } = useSubscriptionsCheckQuery(name)



    const [loading, setLoading] = useState(false);

    const [emailSearch, setEmailSearch] = useState();

    const [shouldFetch, setShouldFetch] = useState(false);

    const { data: businessProfilesSearch, isLoading: isLoadingBusinessProfiles } = useSearchBusinessProfilesQuery(decryptEmail, {
        skip: !shouldFetch,
    });

    const [createBusinessProfile, { isLoading: isCreateProfileLoading, error: createProfileError }] = useCreateBusinessProfileMutation();
    const [encryptedCode, setEncryptedCode] = useState();

    async function hashData(data) {
        const encoder = new TextEncoder();
        const dataBuffer = encoder.encode(data?.toString().trim()?.toLowerCase() || '');
        const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
        return Array.from(new Uint8Array(hashBuffer)).map(b => b.toString(16).padStart(2, '0')).join('');
    }

    async function sendPixel() {
        const hashedName = await hashData(name);
        const hashedEmail = await hashData(decryptEmail);
        sendFb("Lead", {name: name}, { user_data: { fn: hashedName, em: hashedEmail}} );
    }

    useEffect(() => {
        if (!isLoadingBusinessProfiles && businessProfilesSearch && shouldFetch) {
            queryParams.set('code', encryptedCode);
            queryParams.set('un', encryptText(name));
            queryParams.set('new-account', 1);
            sendPixel()
            sendData()
            history.push({
                pathname: '/name',
                search: `?${queryParams.toString()}`,
            });
        }
    }, [businessProfilesSearch, isLoadingBusinessProfiles, shouldFetch, name])

   

    const handleCreateProfile = async () => {
        const data = {
            direction: queryParams.get("direction")
                ? queryParams.get("direction")
                : "PRODUCT",
            ...queryParams.get("productsType") && { productsType: queryParams.get("productsType") },
            ...queryParams.get("stage") && { businessStage: queryParams.get("stage") },
            ...name && { userName: name },
            ...decryptEmail && { email: decryptEmail },
            ...queryParams.get("ad-channels-value") && { sellChannels: queryParams.get("ad-channels-value") },
            ...queryParams.get("goals-text") && { goal: queryParams.get("goals-text") },
            ...queryParams.get("platforms-value") && {
                sitePlatform: queryParams.get("platforms-value").replace(/\.svg/g, '')
                    .replace(/^./, (char) => char.toUpperCase())
            },
            ...queryParams.get("current") && { ordersPerMonth: queryParams.get("current") },
            ...queryParams.get("target") && { ordersGoal: queryParams.get("target") },
            ...queryParams.get("period") && { ordersGoalPeriod: queryParams.get("period")?.toLowerCase() },
            data: {
                videoAds: queryParams.get("video-ads") ? true : false,
                videoAvatars: queryParams.get("video-avatars") ? true : false,
                videoTemplates: queryParams.get("video-templates") ? true : false,
                videoScripts: queryParams.get("video-scripts") ? true : false,
                videoHooks: queryParams.get("video-hooks") ? true : false,
                videoConversion: queryParams.get("video-conversion") ? true : false,
                staticAds: queryParams.get("static-ads") ? true : false,
                staticTemplates: queryParams.get("static-templates") ? true : false,
                staticExamples: queryParams.get("static-examples") ? true : false,
                staticText: queryParams.get("static-text") ? true : false,
                staticEditor: queryParams.get("static-editor") ? true : false,
                staticBulk: queryParams.get("static-bulk") ? true : false,
                adCampaigns: queryParams.get("ad-campaigns") ? true : false,
                adChannels: queryParams.get("ad-channels") ? true : false,
                adTargeting: queryParams.get("ad-targeting") ? true : false,
                adOptimization: queryParams.get("ad-optimization") ? true : false,
                adReports: queryParams.get("ad-reports") ? true : false,
                adCopilot: queryParams.get("ad-copilot") ? true : false,
                adPlatform: queryParams.get("platforms-value") ? true : false,
                ...queryParams.get("productivity-goals-id") && { productivityGoalsId: queryParams.get("productivity-goals-id") },
                ...queryParams.get("target-id") && { targetId: queryParams.get("target-id") },
                ...queryParams.get("goals") && { goalsId: queryParams.get("goals") },
            }
        };

        try {
            await createBusinessProfile(data).unwrap();
            setShouldFetch(true);
            // console.log('Профиль успешно создан');
        } catch (err) {
            setLoading(false);
            console.error("Ошибка создания профиля:", err);
        }
    };


    const handleRegister = async () => {
        try {
            const response = await register(decryptEmail).unwrap();
            console.log('Registration successful:', response);


            const encrypted = await encryptText(response.code, secretKey);
            localStorage.setItem('accessToken', response.data.accessToken);
            localStorage.setItem('refreshToken', response.data.refreshToken);
            localStorage.setItem('authToken', response.data.authToken);

            setEncryptedCode(encrypted)
            if (name) {
                const changeName = await updateUsers({
                    name: name,
                });
            }
            await handleCreateProfile();
            await businessProfilesSearch()
        } catch (err) {

            if (err.data && err.data.message === "User already exist") {
                const dataSubscription = await subscriptionData;
                setEmailSearch(name);

                queryParams.set('un', encryptText(name));
                const hashedName = await hashData(name);
                const hashedEmail = await hashData(decryptEmail);
                sendFb("Lead", {name: name}, { user_data: { fn: hashedName, em: hashedEmail}} );
                sendData()
                history.push({
                    pathname: dataSubscription?.data?.status === "ACTIVE" ? '/welcome' : '/name',
                    search: `?${queryParams.toString()}`,
                });
            }
            console.error('Registration failed:', err);
        }
    };


    const sendData = async () => {
        const formdata = new FormData();
        formdata.append("domen", 'stаrt.usezeely.com');
        formdata.append("email", decryptEmail);
        formdata.append("utmSource", localStorage.getItem("utmSource"));
        formdata.append("utmMedium", localStorage.getItem("utmMedium"));
        formdata.append("utmCampaign", localStorage.getItem("utmCampaign"));
        formdata.append("utmContent", localStorage.getItem("utmContent"));
        formdata.append("utmTerm", localStorage.getItem("utmTerm"));
        try {
            const response = await axios.post("https://zee.sale/send-1-ai.php", formdata, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            console.log(response.data);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className="namePage ">
            <div className="page">
                <PageContent>
                    <div className="page-content">
                        <CustomTitle
                            style={{ marginBottom: '24rem' }}
                            title="What's your name?"
                        />
                        <div
                            className={`input ${error ? 'error' : ''}`}
                            style={{ paddingLeft: '46rem', paddingRight: '16rem' }}>
                            <input
                                type="text"
                                placeholder="Name"
                                value={name}
                                onChange={handleInputChange}
                            />
                            <div className={`input-border ${name === '' ? 'empty' : ''}`}></div>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.13689 1.83337H10.8629C12.0046 1.83337 12.9022 1.83337 13.6242 1.89236C14.3602 1.95249 14.9722 2.07724 15.5275 2.36018C16.437 2.82356 17.1764 3.56297 17.6398 4.47242C17.9227 5.02771 18.0475 5.63973 18.1076 6.37576C18.1666 7.09774 18.1666 7.99534 18.1666 9.13694V10.8631C18.1666 12.0047 18.1666 12.9023 18.1076 13.6243C18.0475 14.3603 17.9227 14.9724 17.6398 15.5277C17.1764 16.4371 16.437 17.1765 15.5275 17.6399C14.9722 17.9228 14.3602 18.0476 13.6242 18.1077C12.9022 18.1667 12.0046 18.1667 10.863 18.1667H9.13682C7.99522 18.1667 7.09762 18.1667 6.37564 18.1077C5.63961 18.0476 5.02759 17.9228 4.4723 17.6399C3.56285 17.1765 2.82344 16.4371 2.36005 15.5277C2.07712 14.9724 1.95237 14.3603 1.89223 13.6243C1.83324 12.9023 1.83325 12.0047 1.83325 10.8631V9.13701C1.83325 7.99538 1.83324 7.09776 1.89223 6.37576C1.95237 5.63973 2.07712 5.02771 2.36005 4.47242C2.82344 3.56297 3.56285 2.82356 4.4723 2.36018C5.02759 2.07724 5.63961 1.95249 6.37564 1.89236C7.09763 1.83337 7.99526 1.83337 9.13689 1.83337ZM6.48421 3.22126C5.83064 3.27466 5.41362 3.37698 5.07762 3.54818C4.41905 3.88374 3.88362 4.41917 3.54806 5.07774C3.37686 5.41374 3.27454 5.83076 3.22114 6.48434C3.1671 7.14569 3.16659 7.98893 3.16659 9.16671V10.8334C3.16659 12.0111 3.1671 12.8544 3.22114 13.5157C3.27454 14.1693 3.37686 14.5863 3.54806 14.9223C3.74569 15.3102 4.01264 15.6554 4.33325 15.9421V15.8334C4.33325 13.6242 6.12411 11.8334 8.33325 11.8334H11.6666C13.8757 11.8334 15.6666 13.6242 15.6666 15.8334V15.9421C15.9872 15.6554 16.2541 15.3102 16.4518 14.9223C16.623 14.5863 16.7253 14.1693 16.7787 13.5157C16.8327 12.8544 16.8333 12.0111 16.8333 10.8334V9.16671C16.8333 7.98893 16.8327 7.14569 16.7787 6.48434C16.7253 5.83076 16.623 5.41374 16.4518 5.07774C16.1162 4.41917 15.5808 3.88374 14.9222 3.54818C14.5862 3.37698 14.1692 3.27466 13.5156 3.22126C12.8543 3.16723 12.011 3.16671 10.8333 3.16671H9.16658C7.98881 3.16671 7.14557 3.16723 6.48421 3.22126ZM14.3333 16.6607V15.8334C14.3333 14.3606 13.1393 13.1667 11.6666 13.1667H8.33325C6.86049 13.1667 5.66659 14.3606 5.66659 15.8334V16.6607C5.8935 16.7137 6.1597 16.7523 6.48421 16.7788C7.14557 16.8329 7.98881 16.8334 9.16658 16.8334H10.8333C12.011 16.8334 12.8543 16.8329 13.5156 16.7788C13.8401 16.7523 14.1063 16.7137 14.3333 16.6607ZM9.99992 5.66671C8.9874 5.66671 8.16658 6.48752 8.16658 7.50004C8.16658 8.51256 8.9874 9.33337 9.99992 9.33337C11.0124 9.33337 11.8333 8.51256 11.8333 7.50004C11.8333 6.48752 11.0124 5.66671 9.99992 5.66671ZM6.83325 7.50004C6.83325 5.75114 8.25102 4.33337 9.99992 4.33337C11.7488 4.33337 13.1666 5.75114 13.1666 7.50004C13.1666 9.24894 11.7488 10.6667 9.99992 10.6667C8.25102 10.6667 6.83325 9.24894 6.83325 7.50004Z" fill="#CAD4DD" />
                            </svg>

                            <span style={{ left: '46rem' }}>Name</span>

                            {error && <div className="error-text" style={{ marginLeft: '-46rem' }}>{error}</div>}
                        </div>
                    </div>
                </PageContent>
            </div>



            {/* <WithWizard
                render={({ next, previous, step, steps }) => (
               
                )}
            /> */}

            <MyButton
                onClick={() => {
                    if (isButtonDisabled) {
                        setError('Enter your name');
                        return;
                    }
                    queryParams.set('un', encryptText(name));
                    trackP1Event('onboarding_name', {})
                    if(decryptEmail) {
                        setLoading(true);
                        handleRegister()
                    } else {
                        history.push({
                            pathname: '/signup',
                            search: `?${queryParams.toString()}`
                        });
                    }
           
                }}
                className={`

                ${error ? 'error' : ''}`}
                buttonIcon={''}
                buttonStatus={loading ? "load" : ""}
                buttonText={`${save ? 'Save' : 'Continue'}`}></MyButton>
        </div>
    );
};

export default Name;
